import { render, staticRenderFns } from "./ClassificacaoSelect.vue?vue&type=template&id=3777df8d&"
import script from "./ClassificacaoSelect.vue?vue&type=script&lang=js&"
export * from "./ClassificacaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports